import { AutoColumn } from 'components/Layout/Column'
import boostPools from 'config/constants/boostPools'
import { useTranslation } from 'contexts/Localization'
import React from 'react'
import { Pie, PieChart, Cell } from 'recharts'
import styled from 'styled-components'
import { formatLockPeriod } from 'views/xVvs/helpers'
import { Text, Flex, useMatchBreakpoints } from 'vvs-uikit'

const Dot = styled.span<{ color: string }>`
  width: 13px;
  height: 13px;
  pointer-events: none;
  border: 2px solid ${({ theme }) => theme.colors.invertedContrast};
  border-radius: 50%;
  background-color: ${({ color }) => color};
  margin-right: 8px;
`

const COLORS = ['#BE72D8', '#FFC804', '#516BEE', '#3ACECD']

// Uncomment below if label is needed
// const RADIAN = Math.PI / 180
// const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
//   const radius = innerRadius + (outerRadius - innerRadius) * 0.5
//   const x = cx + radius * Math.cos(-midAngle * RADIAN)
//   const y = cy + radius * Math.sin(-midAngle * RADIAN)

//   return (
//     <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
//       {`${(percent * 100).toFixed(0)}%`}
//     </text>
//   )
// }

const PieChartSection: React.FC<{
  data: {
    pid: string
    value: number
  }[]
}> = ({ data }) => {
  const { t } = useTranslation()
  const { isMobile } = useMatchBreakpoints()

  const total = data.map((x) => x.value).reduce((a, b) => a + b, 0)

  return (
    <Flex justifyContent="space-between" alignItems={isMobile ? 'center' : 'unset'}>
      <Flex flexDirection="column">
        <Text small mb={3}>
          {t('Allocation')}:
        </Text>
        <AutoColumn gap="8px">
          {data.map((d, i) => (
            <Flex alignItems="center" key={d.pid}>
              <Dot color={COLORS[i % COLORS.length]} />
              <Text small bold>
                {formatLockPeriod(boostPools.find((p) => p.pid === parseInt(d.pid)).lockPeriod)}
              </Text>
              <Text small ml={2}>
                {((d.value / total) * 100).toFixed(1)}%
              </Text>
            </Flex>
          ))}
        </AutoColumn>
      </Flex>
      <Flex>
        <PieChart width={isMobile ? 100 : 200} height={isMobile ? 100 : 200}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            // label={renderCustomizedLabel}
            outerRadius={isMobile ? 50 : 100}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${entry.pid}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </Flex>
    </Flex>
  )
}

export default PieChartSection
